"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var Clip = /*#__PURE__*/(0, _createClass2["default"])(function Clip(x, y, width, height) {
  (0, _classCallCheck2["default"])(this, Clip);
  this.x = x;
  this.y = y;
  this.width = width;
  this.height = height;
});
var _default = exports["default"] = Clip;